module.exports = __webpack_public_path__ + "img/turkana.13249447.png";